import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/**
 * Displays a success toast message using React Toastify.
 *
 * @param {string} message - The message to be displayed in the success toast.
 * @returns {void}
 */
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    closeButton: false,
    bodyStyle: {
      borderRadius: "50%",
      fontFamily: "Outfit, sans-serif",
      width: "fit-content",
    },
  });
};

/**
 * Displays an error toast message using React Toastify.
 *
 * @param {string} message - The message to be displayed in the error toast.
 * @returns {void}
 */
export const showErrorToast = (message) => {
  toast.error(message, {
    position: "top-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    closeButton: false,
    style: {
      borderRadius: "10px",
      fontFamily: "Outfit, sans-serif",
    },
  });
};